export const Privacy = () => {
    return (
      <div className="privacy-policy">
        <h1>PlanetGazer Privacy Policy</h1>
  
        <p>
          <strong>Effective Date:</strong> August 13, 2026
        </p>
  
        <p>
          PlanetGazer ("PlanetGazer," "we," "us," or "our") is a software
          application providing astrological chart and transit information for
          development and testing purposes.
        </p>
  
        <p>
          PlanetGazer is currently a test and development application and is not
          currently offered as a production commercial service.
        </p>
  
        <h2>Information We Collect</h2>
  
        <p>
          PlanetGazer may process information necessary to provide its astrology
          functionality, including information entered by the user such as
          dates, times, and locations used to calculate astrological charts and
          transit information.
        </p>
  
        <p>
          We may also process technical information necessary to operate and
          troubleshoot the application.
        </p>
  
        <h2>QuickBooks Online</h2>
  
        <p>
          QuickBooks Online is not part of PlanetGazer's astrology functionality.
        </p>
  
        <p>
          The PlanetGazer owner may use a private QuickBooks Online integration
          solely for personal software development, testing, and experimentation
          with the QuickBooks Online API.
        </p>
  
        <p>
          This integration is connected only to the owner's authorized
          QuickBooks Online company.
        </p>
  
        <p>QuickBooks Online data accessed through this integration:</p>
  
        <ul>
          <li>is not used to provide PlanetGazer's astrology services;</li>
          <li>is not sold or provided to other users;</li>
          <li>is not used for advertising or targeted marketing;</li>
          <li>
            is not used for analytics unrelated to the owner's development and
            testing;
          </li>
          <li>is not stored in PlanetGazer's database; and</li>
          <li>is not intentionally shared with third parties.</li>
        </ul>
  
        <p>
          The QuickBooks Online integration is a private development and testing
          function and is not currently offered to PlanetGazer users or other
          third parties.
        </p>
  
        <h2>How We Use Information</h2>
  
        <p>Information processed by PlanetGazer is used to:</p>
  
        <ul>
          <li>provide and test astrological chart and transit calculations;</li>
          <li>operate and maintain the application;</li>
          <li>troubleshoot technical problems; and</li>
          <li>develop and test application functionality.</li>
        </ul>
  
        <p>We do not sell personal information.</p>
  
        <h2>Data Retention</h2>
  
        <p>
          PlanetGazer does not intentionally retain QuickBooks Online data on its
          server.
        </p>
  
        <p>
          Other information may be retained only as reasonably necessary to
          operate, maintain, secure, and improve the test application.
        </p>
  
        <h2>Third-Party Services</h2>
  
        <p>
          PlanetGazer may communicate with third-party services when necessary to
          provide or test particular application functionality.
        </p>
  
        <p>
          Those services may have their own privacy policies and terms.
        </p>
  
        <h2>Security</h2>
  
        <p>
          We take reasonable measures to protect information processed by the
          application. However, no internet-based application can guarantee
          absolute security.
        </p>
  
        <h2>Changes to This Privacy Policy</h2>
  
        <p>
          We may update this Privacy Policy from time to time. Any updated
          version will be made available at this URL.
        </p>
  
        <h2>Contact</h2>
  
        <p>
          Questions regarding this Privacy Policy may be directed to:
        </p>
  
        <p>
          <strong>PlanetGazer</strong>
          <br />
          Email:{" "}
          <a href="mailto:support@planetgazer.net">
            support@planetgazer.net
          </a>
        </p>
      </div>
    );
  };